import { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { RowView2 } from "../../../Component/style/common_style";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import DetailItemList from "./Component/Detail_itemList";
import Detail_Notify from "./Component/Detail_notify";
import LiveInfo from "./Component/LiveInfo";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";
import { StoreInfo } from "../../../Component/Interface/Store";
import { useNavigate, useParams } from "react-router-dom";

const Container = styled(RowView2)`
  flex: 1;
  position: relative;
  min-width: 1200px;
  height: 100vh;
`;
const Setting = styled.div`
  flex: 1;
  width: 100%;
  padding-bottom: 5rem;
  margin-left: 2rem;
`;

const LiveDetail = () => {
  const Navigate = useNavigate();
  const { seq } = useParams();
  const [store_info, setStoreInfo] = useState<StoreInfo>();
  const [notifyType, setNotifyType] = useState("ln");
  const [live_start, setLive_start] = useState("");
  const [live_finish, setLive_finish] = useState("");
  const [live_cancle_check, setLive_cancle_check] = useState(false);

  const divRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [change, setChange] = useState(0);

  const live_auth_check = async () => {
    const res = await api.post(url.Communication_url.live_auth_check, {
      seq: seq,
    });
    if (res.data === "n") {
      Navigate("/admin/livelist");
    } else {
      get_store_info();
    }
  };

  const get_store_info = async () => {
    try {
      const res = await api.get(url.Communication_url.store_info);
      setStoreInfo(res.data);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };

  useEffect(() => {
    live_auth_check();
  }, []);

  useEffect(() => {
    if (divRef.current) {
      const height = divRef.current.offsetHeight;
      setHeight(height);
    }
  }, [change]);

  return (
    <Layout_Admin menuname={"라이브 목록"}>
      <Container className="top">
        <LiveInfo
          settingHeight={height}
          live_start={live_start}
          live_finish={live_finish}
          setLive_start={setLive_start}
          setLive_finish={setLive_finish}
          setLive_cancle_check={setLive_cancle_check}
        />

        <Setting ref={divRef}>
          <Detail_Notify
            notifyType={notifyType}
            setNotifyType={setNotifyType}
          />

          <DetailItemList
            live_finish={live_finish}
            setChange_h={setChange}
            live_cancle_check={live_cancle_check}
            setLive_cancle_check={setLive_cancle_check}
            store_info={store_info || ({} as StoreInfo)}
          />
        </Setting>
      </Container>
    </Layout_Admin>
  );
};

export default LiveDetail;
